import { calcRelativeOffset } from '../../../motion/features/layout/utils.js';
import { eachAxis } from '../../../utils/each-axis.js';

function setCurrentViewportBox(visualElement) {
  var projectionParent = visualElement.getProjectionParent();

  if (!projectionParent) {
    visualElement.rebaseProjectionTarget();
    return;
  }

  var relativeOffset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
  eachAxis(function (axis) {
    visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
  });
}

export { setCurrentViewportBox };